import ListingPaymentInfoModal from './ListingPaymentInfoModal';

export default ListingPaymentInfoModal;
